import { useState } from 'react';
import { Link, TextField } from '@mui/material';
import { DEAL_PERMITTED_STAGES } from 'common/constants/analyst-dashboards';
import { ConditionalLoader } from 'dashboard409a/pages/Operations/components';
import Avatar from 'dashboard409a/pages/Operations/components/Avatar/Avatar';
import formatCurrency from 'dashboard409a/utilities/formatCurrency';
import { Container, Field, InfoColumn, Label, LabelRow, Row, StyledAutocomplete, StyledBadge, StyledLinkSpan, Value } from './ValuationDealInfo.styles';
import { Section } from '../Section';
import { DealStageState, ValuationDealInfoProps } from './ValuationDealInfo.props';
import { UserSection } from '../ValuedInformation/ValuedInformation.styles';

const ValuationDealInfo = ({ deal, isLoading, onDealStageChange }: ValuationDealInfoProps) => {
  const [dealStageState, setDealStageState] = useState<DealStageState>(DealStageState.IDLE);
  
  const handleDealStageClick = () => {
    setDealStageState(DealStageState.EDITING);
  }

  
  const handleDealStageChange = async (value: any) => {
    setDealStageState(DealStageState.UPDATING);
    try {
      await onDealStageChange(value.id);
    } finally {
      setDealStageState(DealStageState.IDLE);
    }
  }

  const allDealStageOptions = deal?.dealStageOptions?.sort((a: any, b: any) => DEAL_PERMITTED_STAGES.indexOf(b.title) - DEAL_PERMITTED_STAGES.indexOf(a.title)).map((option: any) => ({
    id: option.id.status_id,
    label: option.title,
  }));

  return (
    <Section title="Deal">
      <Container>
        <InfoColumn>
          <LabelRow>
            <ConditionalLoader isLoading={isLoading} width={200}>
              <Link href={deal?.dealUrl} target="_blank" rel="noopener noreferrer">
                <StyledLinkSpan>{deal?.dealName || '-'}</StyledLinkSpan>
              </Link>
            </ConditionalLoader>
          </LabelRow>
          {deal?.dealNotice && (
            <span>NOTICE: {deal.dealNotice}</span>
          )}
          <LabelRow>
            <Label>Deal Value:</Label>
            <ConditionalLoader isLoading={isLoading} width={200}>
              <Value>{deal?.dealTotal || '-'}</Value>
            </ConditionalLoader>
            <Label>Due:</Label>
            <ConditionalLoader isLoading={isLoading} width={200}>
              <Value>{deal?.due || '-'}</Value>
            </ConditionalLoader>
            <Label>NET:</Label>
            <ConditionalLoader isLoading={isLoading} width={200}>
              <Value>{formatCurrency({ value: deal?.net || '-' })}</Value>
            </ConditionalLoader>
          </LabelRow>
          <LabelRow>
            <Field>
              <Label>Engagement Manager</Label>
              <UserSection>
                <Avatar
                  src={deal?.engagementManagerImageSrc || ''}
                  name={deal?.engagementManager || '-'}
                  roleTitle={deal?.engagementManagerRole || '-'}
                  isLoading={isLoading}
                />
              </UserSection>
            </Field>
          </LabelRow>
        </InfoColumn>
        <Row>
          <Field>
            <Label>Deal Date</Label>
            <ConditionalLoader isLoading={isLoading} width={200}>
              <Value>{deal?.dealDate || '-'}</Value>
            </ConditionalLoader>
          </Field>
        </Row>

        <InfoColumn>
          <LabelRow>
            <ConditionalLoader isLoading={isLoading} width={200}>
              <Value>Contract: {deal?.contractStatus || '-'}</Value>
              <Link href={deal?.ELURL ? deal?.ELURL : ''} target="_blank" rel="noopener noreferrer"> {deal?.ELURL ? 'EL' : ''}</Link>
              <Link href={deal?.signedELURL ? deal?.signedELURL : ''} target="_blank" rel="noopener noreferrer"> {deal?.signedELURL ? 'Signed EL' : ''}</Link>
            </ConditionalLoader>
          </LabelRow>
          <ConditionalLoader isLoading={dealStageState === DealStageState.UPDATING} width={200}>
            {dealStageState === DealStageState.IDLE && <StyledBadge onClick={handleDealStageClick}>{deal?.dealStage || 'Deal Stage not set'}</StyledBadge>}
            {dealStageState === DealStageState.EDITING && (
              <StyledAutocomplete
                value={allDealStageOptions?.find((option: any) => option.label === deal?.dealStage) || null}
                options={allDealStageOptions || []}
                getOptionDisabled={(option: any) => !DEAL_PERMITTED_STAGES.includes(option.label)}
                renderInput={(params) => <TextField {...params} variant="outlined" />}
                disableClearable
                onChange={(event, value) => {
                  handleDealStageChange(value);
                }}
                renderOption={(props, option: any) => (
                  <li {...props} key={option.id} style={{
                    fontSize: '0.875rem',
                  }}>
                    {option.label}
                  </li>
                )}
              />
            )}
          </ConditionalLoader>
        </InfoColumn>
      </Container>
    </Section>
  )
};

export default ValuationDealInfo;
